import { flattenObjectKeys } from "../../utils/flattenObjectKeys";

export default function mapAnswersToLead(answers) {
  const formattedAnswers = flattenObjectKeys(answers);
  const isDev = process.env.REACT_APP_DEPLOYMENT_ENV !== "production";

  return {
    caseDescription: formattedAnswers.CASE_DESCRIPTION,
    caseType: formattedAnswers.VIOLATION_TYPE,
    contactType: "Person",
    didAccidentOccur: formattedAnswers.ACCIDENT_OCCURRED,
    didDamageOccur: formattedAnswers.DAMAGE_OCCURRED,
    didReceiveLetter: formattedAnswers.RECEIVED_LETTER_TYPE !== "NONE",
    email: formattedAnswers.EMAIL_ADDRESS,
    firstName: formattedAnswers.FIRST_NAME,
    hasLegalInsurance: getLegalInsurance(formattedAnswers.LEGAL_INSURANCE),
    isInProbation: formattedAnswers.IN_PROBATION,
    isProfessionallyDependentOnLicence:
      formattedAnswers.PROFESSIONALLY_DEPENDENT_LICENCE,
    lastName: formattedAnswers.LAST_NAME,
    numberOfPenaltyPoints: formattedAnswers.POINTS_AMOUNT,
    phoneNumber: formattedAnswers.PHONE_NUMBER,
    receivedLetterType: formattedAnswers.RECEIVED_LETTER_TYPE,
    redLightDuration: formattedAnswers.RED_LIGHT_DURATION,
    source: "AUTO MOTOR UND SPORT",
    speedingLocation: formattedAnswers.SPEEDING_LOCATION,
    speedRange: getSpeedRange(formattedAnswers.SPEED_RANGE),
    speedViolationRange: getSpeedViolationRange(
      formattedAnswers.SPEED_VIOLATION_RANGE
    ),
    type: "FREEM",
    tailingDistance: formattedAnswers.TAILING_DISTANCE,
    vehicleType: formattedAnswers.VEHICLE_TYPE,
    werePeopleEndangered: formattedAnswers.RISK_OF_DANGER,
    wasStoppedByPolice: formattedAnswers.STOPPED_BY_POLICE,
    billingTerms: getBillingTerms(formattedAnswers.LEGAL_INSURANCE),
    isTestCase: isDev
  };
}

function getBillingTerms(answer) {
  if (answer === "YES") return "LEGAL_INSURANCE";
  if (answer === "NO") return "SELF_PAYER";
}

function getSpeedViolationRange(answer) {
  if (answer === "BETWEEN_0_20") return "LESS_THAN_20";
  if (answer === "OVER_40") return "MORE_THAN_40";
  return answer;
}

function getSpeedRange(answer) {
  if (answer === "OVER_130") return "MORE_THAN_130";
  return answer;
}

function getLegalInsurance(answer) {
  if (answer === "YES") return true;
  if (answer === "NO") return false;
}
